import axios from 'axios'
import { notify } from 'react-notify-toast'

import { URIS, loadHeaders } from '../Uris'
import { detectionsConstants, uiConstants } from '../constants'

export function loadLots(payload) {
  return (dispatch) => {
    dispatch(loadingLots())
    axios({
      method: 'GET',
      url: URIS.lots,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(loadLotsSuccess(res.data))
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadLotsFailure(error.response.statusText))
        } else {
          dispatch(loadLotsFailure(error.message))
        }
        notify.show('Errore caricamento lotti', uiConstants.toast.error, 3000)
      })
  }
}

function loadingLots() {
  return {
    type: detectionsConstants.LOADING_LOTS
  }
}

function loadLotsSuccess(payload) {
  return {
    type: detectionsConstants.LOADING_LOTS_SUCCESS,
    payload
  }
}

function loadLotsFailure(payload) {
  return {
    type: detectionsConstants.LOADING_LOTS_FAILURE,
    payload
  }
}

export function addLot(payload) {
  return (dispatch) => {
    dispatch(updatingLot())
    axios({
      method: 'POST',
      url: URIS.lots,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(loadLotsSuccess(res.data))
        notify.show('Lotto aggiunto', uiConstants.toast.success, 3000)
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadDetectionsFailure(error.response.statusText))
        } else {
          dispatch(loadDetectionsFailure(error.message))
        }
        notify.show('Errore salvataggio lotto', uiConstants.toast.error, 3000)
      })
  }
}

export function deleteLot(payload) {
  return (dispatch) => {
    dispatch(updatingLot())
    axios({
      method: 'DELETE',
      url: URIS.lots,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(loadLotsSuccess(res.data))
        notify.show('Lotto eliminato', uiConstants.toast.success, 3000)
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadDetectionsFailure(error.response.statusText))
        } else {
          dispatch(loadDetectionsFailure(error.message))
        }
        notify.show('Errore eliminazione lotto', uiConstants.toast.error, 3000)
      })
  }
}

function updatingLot() {
  return {
    type: detectionsConstants.UPDATING_LOTS
  }
}

export function loadDetections(payload) {
  return (dispatch) => {
    dispatch(loadingDetections())
    axios({
      method: 'GET',
      url: URIS.detections + '?id=' + payload,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(loadDetectionsSuccess(res.data))
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadDetectionsFailure(error.response.statusText))
        } else {
          dispatch(loadDetectionsFailure(error.message))
        }
        notify.show(
          'Errore caricamento anomalie',
          uiConstants.toast.error,
          3000
        )
      })
  }
}

function loadingDetections() {
  return {
    type: detectionsConstants.LOADING_DETECTIONS
  }
}

function loadDetectionsSuccess(payload) {
  return {
    type: detectionsConstants.LOADING_DETECTIONS_SUCCESS,
    payload
  }
}

function loadDetectionsFailure(payload) {
  return {
    type: detectionsConstants.LOADING_DETECTIONS_FAILURE,
    payload
  }
}

export function assignLot(payload) {
  return (dispatch) => {
    dispatch(assigningLot())
    axios({
      method: 'POST',
      url: URIS.detections,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(assignLotSuccess(res.data))
        notify.show(
          'Anomalie associate al lotto con successo',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(assignLotFailure(error.response.statusText))
        } else {
          dispatch(assignLotFailure(error.message))
        }
        notify.show(
          'Errore assegnazione anomalie al lotto',
          uiConstants.toast.error,
          3000
        )
      })
  }
}

function assigningLot() {
  return {
    type: detectionsConstants.ASSIGNING_LOT
  }
}

function assignLotSuccess(payload) {
  return {
    type: detectionsConstants.ASSIGN_LOT_SUCCESS,
    payload
  }
}

function assignLotFailure(payload) {
  return {
    type: detectionsConstants.ASSIGN_LOT_FAILURE,
    payload
  }
}

export function removeLotPerson(payload) {
  return (dispatch) => {
    dispatch(updatingLotPerson())
    axios({
      method: 'DELETE',
      url: URIS.detections,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(updatingLotPersonSuccess(res.data))
        notify.show(
          'Ruolo rimosso con successo',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(updatingLotPersonFailure(error.response.statusText))
        } else {
          dispatch(updatingLotPersonFailure(error.message))
        }
        notify.show('Errore rimozione ruolo', uiConstants.toast.error, 3000)
      })
  }
}

export function addLotPerson(payload) {
  return (dispatch) => {
    dispatch(updatingLotPerson())
    axios({
      method: 'PUT',
      url: URIS.detections,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(updatingLotPersonSuccess(res.data))
        notify.show(
          'Ruolo assegnato con successo',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(updatingLotPersonFailure(error.response.statusText))
        } else {
          dispatch(updatingLotPersonFailure(error.message))
        }
        notify.show('Errore assegnazione ruolo', uiConstants.toast.error, 3000)
      })
  }
}

function updatingLotPerson() {
  return {
    type: detectionsConstants.UPDATING_LOT_PERSON
  }
}

function updatingLotPersonSuccess(payload) {
  return {
    type: detectionsConstants.UPDATING_LOT_PERSON_SUCCESS,
    payload
  }
}

function updatingLotPersonFailure(payload) {
  return {
    type: detectionsConstants.UPDATING_LOT_PERSON_SUCCESS,
    payload
  }
}

export function updateLot(payload) {
  return (dispatch) => {
    dispatch(updatingLot())
    axios({
      method: 'PUT',
      url: URIS.lots,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(loadLotsSuccess(res.data))
        notify.show(
          'Lotto aggiornato con successo',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(loadDetectionsFailure(error.response.statusText))
        } else {
          dispatch(loadDetectionsFailure(error.message))
        }
        notify.show('Errore spostamento lotto', uiConstants.toast.error, 3000)
      })
  }
}

export function setResolvedStatus(payload) {
  return (dispatch) => {
    dispatch(changeResolvedStatus(payload))
    axios({
      method: 'PUT',
      url: URIS.status,
      data: payload,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(changeResolvedStatusSuccess(res.data))
        notify.show(
          'Stato anomlia salvato con successo',
          uiConstants.toast.success,
          3000
        )
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(changeResolvedStatusFailure(error.response.statusText))
        } else {
          dispatch(changeResolvedStatusFailure(error.message))
        }
        notify.show(
          'Errore salvataggio stato anomalia',
          uiConstants.toast.error,
          3000
        )
      })
  }
}

function changeResolvedStatus() {
  return {
    type: detectionsConstants.CHANGE_RESOLVED_STATUS
  }
}

function changeResolvedStatusSuccess(payload) {
  return {
    type: detectionsConstants.CHANGE_RESOLVED_STATUS_SUCCESS,
    payload
  }
}

function changeResolvedStatusFailure(payload) {
  return {
    type: detectionsConstants.CHANGE_RESOLVED_STATUS_FAILURE,
    payload
  }
}
